import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { register as registerSwiperElements } from 'swiper/element/bundle';
import packageInfo from '../package.json';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';
import { getClient } from '@sentry/angular';
import { patchMixpanelXhrCredentials } from './app/core/mixpanel-xhr-credentials.patch';
import { getMixpanelApiHost } from './app/core/mixpanel-api-host';
import { configureMapboxWorker } from './app/shared/mapbox/configure-mapbox-worker';

patchMixpanelXhrCredentials((url) => url.startsWith(getMixpanelApiHost()));

console.log('%c⧭ Version ', 'color: #00861b; font-size: 16px; font-weight: 600', packageInfo.version);
if (environment.production) {
  // close log on production
  console.log = () => {};
}

// Sentry initializes once a DSN is available (app bootstrap tries first; authenticated config supplies DSN after login).

configureMapboxWorker();

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    const loader = document.getElementById('global-loader');
    if (loader) {
      loader.style.opacity = '0';
      loader.style.visibility = 'hidden';
      setTimeout(() => loader.remove(), 300); // optional cleanup
    }
  })
  .catch((err) => {
    console.error('Failed to bootstrap application:', err);
    if (getClient()) {
      Sentry.captureException(err, {
        tags: { component: 'Bootstrap' },
        extra: { bootstrapError: true },
      });
    }
  });

registerSwiperElements();
